import * as React from "react";
const SvgFiRrCloudRainbow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cloud-rainbow_svg__a)">
      <path
        fill="#062147"
        d="M9.236 6.4A17.98 17.98 0 0 1 23 0a1 1 0 0 1 0 2 15.98 15.98 0 0 0-12.235 5.689A1 1 0 1 1 9.236 6.4M23 8a10.01 10.01 0 0 0-7.453 3.333 1 1 0 0 0 1.49 1.334A8.01 8.01 0 0 1 23.002 10a1 1 0 0 0 0-2m0-4a13.88 13.88 0 0 0-10.1 4.308 1 1 0 1 0 1.444 1.384A11.9 11.9 0 0 1 23.002 6a1 1 0 0 0 0-2m-5.134 16.172A4.95 4.95 0 0 1 13.1 24c-.866.017-3.08.026-5.2.026-3.696-.111-6.572.708-7.774-2.592a3.625 3.625 0 0 1 2-4.258A6 6 0 0 1 13.543 13.7c.137.326.287.359.588.427l.175.042a5.013 5.013 0 0 1 3.56 6.003M13.785 16.1a2.72 2.72 0 0 1-2.085-1.629 4 4 0 0 0-7.609 2.352 1.89 1.89 0 0 1-1.18 2.19A1.566 1.566 0 0 0 3.531 22c1.5.036 7.9.029 9.527 0q.333-.006.658-.082a2.97 2.97 0 0 0 2.2-2.192 3.023 3.023 0 0 0-2.133-3.626M23 12a5.96 5.96 0 0 0-4.8 2.4 1 1 0 1 0 1.6 1.2A3.96 3.96 0 0 1 23 14a1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cloud-rainbow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudRainbow;
